import * as React from 'react';

import './UnderlineDropdown.style.css';

export interface TUnderlineDropdownItem {
  value: any; // could be a string or a number
  text: string;
}

export interface TUnderlineDropdownProps {
  name: string;
  value?: any;
  className?: string;
  options?: TUnderlineDropdownItem[];
  onChange?: (event: any) => void;
  isDisabled?: boolean;
  smallDropdown?: boolean;
  onMousedown?: (event: any) => void;
  onBlur?: (event: any) => void;
}

export const UnderlineDropdown: React.StatelessComponent<
  TUnderlineDropdownProps
> = ({
  name,
  value,
  className,
  options,
  onChange,
  isDisabled,
  smallDropdown,
  onMousedown,
  onBlur,
}) => {
  if (className) {
    className += ' underline-dropdown mt-2';
  } else {
    className = 'underline-dropdown mt-2';
  }

  if (isDisabled) {
    className += ' disabled';
  }

  if (smallDropdown) {
    className += ' small-underline-dropdown';
  }

  return (
    <select
      name={name}
      value={value}
      onChange={onChange}
      onMouseDown={onMousedown}
      onBlur={onBlur}
      className={className}
      disabled={isDisabled}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  );
};
